import { ActivationPayload, AuthenticationPayload } from '@dev/ee-api/ee-api-models';
import { Action } from 'redux';

export enum AuthActionTypes {
    RESEND_2FA = '@@twofactorauth/RESEND_2FA',
    RESEND_2FA_SUCCESS = '@@twofactorauth/RESEND_2FA_SUCCESS',
    AUTH_ERROR = '@@twofactorauth/RESENT_2FA_ERROR',
    RESEND_ACTIVATION_EMAIL = '@@auth/RESEND_ACTIVATION_EMAIL',
    RESEND_ACTIVATION_EMAIL_SUCCESS = '@@auth/RESEND_ACTIVATION_EMAIL_SUCCESS',
    RESEND_ACTIVATION_EMAIL_ERROR = '@@auth/RESEND_ACTIVATION_EMAIL_ERROR',
    RESEND_ACTIVATION_EMAIL_USER = '@@auth/RESEND_ACTIVATION_EMAIL_USER',
}

export interface Resend2FACodeAction extends Action {
    type: AuthActionTypes.RESEND_2FA;
    payload: AuthenticationPayload;
    meta: {
        thunk: boolean;
    };
}
export interface Resend2FACodeSuccessAction extends Action {
    type: AuthActionTypes.RESEND_2FA_SUCCESS;
    meta: Record<string, unknown>;
}
export interface AuthErrorAction extends Action {
    type: AuthActionTypes.AUTH_ERROR;
    error: boolean;
    meta: Record<string, unknown>;
}

export interface ResendActivationEmailAction extends Action {
    type: AuthActionTypes.RESEND_ACTIVATION_EMAIL;
    payload: ActivationPayload;
    meta: {
        thunk: boolean;
    };
}
export interface ResendActivationEmailSuccessAction extends Action {
    type: AuthActionTypes.RESEND_ACTIVATION_EMAIL_SUCCESS;
    meta: Record<string, unknown>;
}
export interface ResendActivationEmailErrorAction extends Action {
    type: AuthActionTypes.RESEND_ACTIVATION_EMAIL_ERROR;
    error: boolean;
    meta: Record<string, unknown>;
    payload: Record<string, unknown>;
}

export interface ResendActivationEmailUserAction extends Action {
    type: AuthActionTypes.RESEND_ACTIVATION_EMAIL_USER;
    payload: ActivationPayload;
    previousMeta: Record<string, unknown>;
    meta: {
        thunk: boolean;
    };
}
